<form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
  <h3 class="text-primary text-[20px] font-[600]" i18n="@@adminAddUserTitle">User Information</h3>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
    <div class="flex flex-col gap-2">
      <label for="firstName" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@adminUserFormFirstNameLabel">
        First Name
        <span class="text-danger-text">*</span>
      </label>
      <input
        id="firstName"
        type="text"
        formControlName="firstName"
        placeholder="Enter first name"
        i18n-placeholder="@@adminUserFormFirstNamePlaceholder"
        class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
        [class.border-red-500]="userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched" />
      @if (userForm.get("firstName")?.invalid && userForm.get("firstName")?.touched) {
        <span class="text-danger-text text-[12px]">
          @if (userForm.get("firstName")?.errors?.["required"]) {
            <span i18n="@@adminUserFormErrorFirstNameRequired">First name is required</span>
          }
          @if (userForm.get("firstName")?.errors?.["minlength"]) {
            <span i18n="@@adminUserFormErrorFirstNameMinLength">First name must be at least 2 characters</span>
          }
          @if (userForm.get("firstName")?.errors?.["maxlength"]) {
            <span i18n="@@adminUserFormErrorFirstNameMaxLength">First name must be at most 50 characters</span>
          }
          @if (userForm.get("firstName")?.errors?.["pattern"]) {
            <span i18n="@@adminUserFormErrorFirstNamePattern">First Name can only contain letters and spaces</span>
          }
        </span>
      }
    </div>

    <div class="flex flex-col gap-2">
      <label for="lastName" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@adminUserFormLastNameLabel">
        Last Name
        <span class="text-danger-text">*</span>
      </label>
      <input
        id="lastName"
        type="text"
        formControlName="lastName"
        placeholder="Enter last name"
        i18n-placeholder="@@adminUserFormLastNamePlaceholder"
        class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
        [class.border-red-500]="userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched" />
      @if (userForm.get("lastName")?.invalid && userForm.get("lastName")?.touched) {
        <span class="text-danger-text text-[12px]">
          @if (userForm.get("lastName")?.errors?.["required"]) {
            <span i18n="@@adminUserFormErrorLastNameRequired">Last name is required</span>
          }
          @if (userForm.get("lastName")?.errors?.["minlength"]) {
            <span i18n="@@adminUserFormErrorLastNameMinLength">Last name must be at least 2 characters</span>
          }
          @if (userForm.get("lastName")?.errors?.["maxlength"]) {
            <span i18n="@@adminUserFormErrorLastNameMaxLength">Last name must be at most 50 characters</span>
          }
          @if (userForm.get("lastName")?.errors?.["pattern"]) {
            <span i18n="@@adminUserFormErrorLastNamePattern">Last Name can only contain letters and spaces</span>
          }
        </span>
      }
    </div>

    <div class="flex flex-col gap-2">
      <label for="phoneNumber" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@adminUserFormPhoneLabel">
        Mobile
        <span class="text-danger-text">*</span>
      </label>
      <div
        class="mobile-input-container border-border bg-surface-subtle focus-within-border-gray-strong hover-border-input-border rounded-[6px] border-[1px] focus-within:bg-white"
        [class.border-red-500]="userForm.get('phoneNumber')?.invalid && userForm.get('phoneNumber')?.touched">
        <div class="country-code">
          <span>🇪🇬</span>
          <span>+20</span>
        </div>
        <input
          id="phoneNumber"
          type="text"
          formControlName="phoneNumber"
          placeholder="1234567890"
          (input)="onPhoneInput($event)"
          class="placeholder-text-gray w-full bg-transparent px-3 py-2 text-[14px] focus:outline-none" />
      </div>
      @if (userForm.get("phoneNumber")?.invalid && userForm.get("phoneNumber")?.touched) {
        <span class="text-danger-text text-[12px]">
          @if (userForm.get("phoneNumber")?.errors?.["required"]) {
            <span i18n="@@adminUserFormErrorPhoneRequired">Mobile number is required</span>
          } @else if (userForm.get("phoneNumber")?.errors?.["invalidCharacters"]) {
            <span i18n="@@registerMobileInvalidPattern">Mobile Number must contain only numbers</span>
          } @else if (
            userForm.get("phoneNumber")?.errors?.["invalidLength"] ||
            userForm.get("phoneNumber")?.errors?.["mobileNumber"]
          ) {
            <span i18n="@@registerMobileInvalidPatternNumber">Invalid Mobile Number</span>
          }
          <!-- @if (userForm.get("phoneNumber")?.errors?.["pattern"]) {
            <span i18n="@@adminUserFormErrorPhoneInvalid">Mobile number must contain only numbers</span>
          } -->
        </span>
      }
    </div>

    <div class="flex flex-col gap-2">
      <label for="email" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@adminUserFormEmailLabel">
        Email
        <span class="text-danger-text">*</span>
      </label>
      <input
        id="email"
        type="email"
        formControlName="email"
        placeholder="example@email.com"
        class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
        [class.border-red-500]="userForm.get('email')?.invalid && userForm.get('email')?.touched" />
      @if (userForm.get("email")?.invalid && userForm.get("email")?.touched) {
        <span class="text-danger-text text-[12px]">
          <!-- @if (userForm.get("email")?.errors?.["required"]) {
            <span i18n="@@adminUserFormErrorEmailRequired">Email is required</span>
          } -->
          @if (userForm.get("email")?.errors?.["minlength"] && !userForm.get("email")?.errors?.["pattern"]) {
            <span i18n="@@adminUserFormErrorEmailMinLength">Email must be at least 5 characters</span>
          }
          @if (userForm.get("email")?.errors?.["maxlength"] && !userForm.get("email")?.errors?.["pattern"]) {
            <span i18n="@@adminUserFormErrorEmailMaxLength">Email must be at most 150 characters</span>
          }
          @if (
            userForm.get("email")?.errors?.["pattern"] ||
            (userForm.get("email")?.errors?.["invalidEmail"] && !userForm.get("email")?.errors?.["minlength"])
          ) {
            <span i18n="@@adminUserFormErrorEmailInvalid">Please enter a valid email address</span>
          }
        </span>
      }
    </div>

    <div class="flex flex-col gap-2">
      <label for="role" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@adminUsersFilterRoleLabel">
        Role
        <span class="text-danger-text">*</span>
      </label>
      <div class="relative w-full">
        <div
          (click)="onToggleRoleMenu()"
          class="border-border bg-surface-subtle hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none">
          <div class="flex w-full items-center justify-between">
            <p i18n="@@adminUserFormSelectRole">Select role</p>
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48">
              <path
                class="stroke-black-solid"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
                d="M36 18L24 30L12 18" />
            </svg>
          </div>
        </div>
        @if (isRoleMenu()) {
          <div class="absolute mt-2 flex max-h-48 w-full flex-col gap-3 overflow-y-auto bg-white p-4 shadow-xl">
            @for (role of rolesTitle(); track role.id) {
              <div class="translation-colors hover-bg-hover-surface-alt flex items-center gap-2 rounded-xl px-4">
                <input
                  type="checkbox"
                  [id]="'role-' + role.id"
                  class="shadow-inner-lg h-4 w-4 rounded-none accent-blue-500"
                  (change)="onRoleSelected($event, role.id)"
                  [checked]="userForm.get('role')?.value?.includes(role.id)" />

                <label [for]="'role-' + role.id" class="h-full w-full cursor-pointer px-3 py-1">
                  {{ role.title }}
                </label>
              </div>
            }
          </div>
        }
      </div>
      <!-- <select
        id="role"
        formControlName="role"
        class="rounded-[6px] border-[1px] border-[#E5E7EB] bg-[#F9FAFB] px-3 py-2 text-[14px] hover:border-[#8b8f94] focus:border-[#5A5D60] focus:bg-white focus:outline-none"
        [class.border-red-500]="userForm.get('role')?.invalid && userForm.get('role')?.touched">
        <option value="" disabled i18n="@@adminUserFormSelectRole">Select role</option>
        @for (role of rolesTitle(); track role.id) {
          <option [value]="role.id">{{ role.title }}</option>
        }
      </select> -->
      @if (userForm.get("role")?.invalid && userForm.get("role")?.touched) {
        <span class="text-danger-text text-[12px]" i18n="@@adminUserFormErrorRoleRequired">Role is required</span>
      }
    </div>
  </div>
  @if (error()) {
    <div>
      <app-error [apiError]="error()" />
    </div>
  }

  <div class="flex justify-end gap-3">
    <button
      type="button"
      (click)="onCancel()"
      class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
      <span i18n="@@adminCategoryFormCancelButton">Cancel</span>
    </button>
    <button
      [disabled]="loading()"
      type="submit"
      [class]="
        'bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer ' +
        (loading() ? 'cursor-not-allowed opacity-50' : '')
      ">
      @if (loading()) {
        <span i18n="@@loading">loading</span>
      } @else {
        <span i18n="@@adminUserFormAddUserButton">Add User</span>
      }
    </button>
  </div>
</form>

<app-successful-creation-modal
  [createdUser]="createdUser()"
  [isOpen]="isSuccessModalOpen()"
  (closeModal)="closeModal()" />
